module.exports = __webpack_public_path__ + "static/img/elder.0a19f69.png";


//////////////////
// WEBPACK FOOTER
// ./static/elder.png
// module id = YwE0
// module chunks = 1